module.exports = __webpack_public_path__ + "static/media/coin.69ca0709.mp3";